import { ItemCard, ItemCardShippingInfo, ItemCardState } from '../../component/item-card/ItemCard';
import type { ItemCardType } from '../../type/common.type';

interface ItemCardsSectionProps extends Omit<ItemCardState, 'item'> {
  display: boolean;
  itemCardList: ItemCardType[];
  displayShipping: boolean;
  displayDeliveryDate: boolean;
  displayProductInfo: boolean;
  displayRemove: boolean;
  actions: {
    getItemCardShippingData: (item: ItemCardType) => ItemCardShippingInfo;
    isDisalbedDecreaseButton: (item: ItemCardType) => boolean;
    isIncreasedDisabledButton: (item: ItemCardType) => boolean;
    handleItemCardIncrease: (item: ItemCardType) => void;
    handleItemCardDecrease: (item: ItemCardType) => void;
    handleRemoveItemCard: (item: ItemCardType) => void;
  };
}

export const ItemCardsSection = (props: ItemCardsSectionProps) => {
  const {
    display,
    itemCardList,
    bogoBadgeUrl,
    displayShipping,
    displayProductInfo,
    displayDeliveryDate,
    displayCounter,
    displayPrice,
    displayRemove,
    actions,
  } = props;
  if (!display) {
    return null;
  }

  return (
    <div style={{ marginTop: 16 }}>
      {itemCardList.map((item) => {
        const { badge, delivery_date } = actions.getItemCardShippingData(item);
        return (
          <ItemCard
            key={item.id}
            item={item}
            shipping={
              displayShipping ? { badge, delivery_date: displayDeliveryDate ? delivery_date : null } : undefined
            }
            bogoBadgeUrl={bogoBadgeUrl}
            displayPrice={displayPrice}
            displayCounter={displayCounter}
            displayProductInfo={displayProductInfo}
            disableMinCounter={actions.isDisalbedDecreaseButton(item)}
            disableMaxCounter={actions.isIncreasedDisabledButton(item)}
            handleIncrease={() => actions.handleItemCardIncrease(item)}
            handleDecrease={() => actions.handleItemCardDecrease(item)}
            handleRemove={displayRemove ? () => actions.handleRemoveItemCard(item) : undefined}
          />
        );
      })}
    </div>
  );
};
